import { Input } from '@material-ui/core';
import { Done } from '@material-ui/icons';
import { rhythm } from 'Themes/typography';
import React from 'react';
import styled from 'styled-components';

// border-top: 1px solid ${({ theme }) => theme.palette.blue.light};
// border-bottom: 1px solid ${({ theme }) => theme.palette.blue.light};
// font-family: ${({ theme }) => theme.typography.headerFontFamily};
const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${rhythm(0.1)} 10px;
  height: 35px;
`;

const Title = styled.div`
  font-weight: 600;
  flex: 1;
  font-size: 0.75rem;
  position: relative;

  @media screen and (min-width: 950px) {
    flex: 0.7;
  }
`;

const InputWrapper = styled.div`
  flex: 1;
`;
const StyledMUInput = styled(Input)`
  & input {
    text-transform: capitalize;
    color: #62727b;
    font-size: 14px;
    padding: 0;
    text-align: right;
  }
`;

class SpecificationItem extends React.PureComponent {
  render() {
    return (
      <Container>
        <Title>
          <div>{this.props.title}:</div>
        </Title>
        <InputWrapper>
          <StyledMUInput
            disabled
            name={this.props.name}
            value={this.props.value}
            fullWidth
          />
        </InputWrapper>
      </Container>
    );
  }
}

export default SpecificationItem;
